export default "__VITE_ASSET__DzQpe4DT__"